// let doctors = [];
export let data = {
  title: "Operasi",
  backBtn: "",
  actionBtn: [
    {
      class: "btn-primary  btn-with-icon-left",
      label: "Operasi Baru",
      link: "/operasi/daftar",
      iconLeft: "add"
    }
  ],
  breadcrumb: []
};
export let tabs = [
  { title: "DIJADWALKAN", filter: "DIJADWALKAN", active: true },
  {
    title: "SEDANG DIPERIKSA",
    filter: "SEDANG DIPERIKSA"
  },
  {
    title: "SELESAI DIPERIKSA",
    filter: "SELESAI DIPERIKSA"
  },
  {
    title: "MENUNGGU PEMBAYARAN",
    filter: "MENUNGGU PEMBAYARAN"
  },
  { title: "SELESAI", filter: "SELESAI" },
  { title: "DIBATALKAN", filter: "DIBATALKAN"}
];
export let references = [
  {
    value: "SEMUA",
    label: "Semua"
  },
  {
    value: "1",
    label: "Dengan Rujukan"
  },
  {
    value: "0",
    label: "Tanpa Rujukan"
  }
];
export let doctors = [

];
export let payments = [
  {
    value: "1",
    label: "Umum"
  },
  {
    value: "2",
    label: "BPJS"
  },
  {
    value: "3",
    label: "Lainnya"
  }
];
export let sorts = [
  {
    value: "desc",
    label: "Terbaru"
  },
  {
    value: "asc",
    label: "Terlama"
  }
];
export let filters = {
  colnum: "",
  columns: [
    {
      label: "dari tanggal",
      type: "date",
      placeholder: "Tanggal periksa",
      name: "created_from",
      value: new Date(),
      mandatory: true,
      colwidth: 3,
      id: "filterDateStart"
    },
    {
      label: "sampai tanggal",
      type: "date",
      placeholder: "Tanggal periksa",
      name: "created_to",
      value: new Date(),
      mandatory: true,
      colwidth: 3,
      id: "filterDateEnd"
    },
    {
      label: "Dokter Operator",
      type: "select",
      placeholder: "Semua",
      value: "",
      name: "id_dokter_operator",
      mandatory: true,
      options: doctors,
      colwidth: 6,
      id: "filterDoctor"
    }
  ]
};
export let sort = {
  colnum: 1,
  columns: [
    {
      label: "Sort By",
      type: "select",
      placeholder: "",
      value: "Terbaru",
      mandatory: true,
      options: sorts
    }
  ]
};
